export const mediumTypes = Object.freeze({
  TRACK: "track",
  IMAGE: "image",
  VIDEO: "video"
})

export const mediumProcessingStates = Object.freeze({
  COMPLETE: "complete",
  IN_PROGRESS: "in_progress"
})

export class Medium {
  constructor({ id, media_type, processing_state, file_url }) {
    this.id = id
    this.type = media_type
    this.processingState = processing_state
    this.fileUrl = file_url
  }

  get isProcessing() {
    return this.processingState === mediumProcessingStates.IN_PROGRESS
  }

  setProcessedFileUrl(fileUrl) {
    this.fileUrl = fileUrl
    this.processingState = mediumProcessingStates.COMPLETE
  }
}
